//* Libraries imports
import { useState } from "react";

//* Service imports
import { templateHistoryService } from "@/features/template/TemplateHistoryService";

//* Types imports
import type { ApiError } from "@/types/api";

export const useDeleteTemplateHistory = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const remove = async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await templateHistoryService.delete(id);

      if (response && "code" in response && "message" in response) {
        const apiError = response as ApiError;
        throw new Error(apiError.message);
      }

      return true;
    } catch (err: any) {
      const errorMessage =
        err.message || "Ocorreu um erro ao deletar o histórico do template";
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { remove, loading, error };
};
